import { SearchX } from 'lucide-react';
import { Text } from '@/components/ui/Text';

/**
 * Rendered after the 800ms grace period when a query returns zero hits
 * (and `partialFailure` is false). A60 Q-A5 / design §6.5.
 */
interface GlobalSearchEmptyStateProps {
  query: string;
}

export function GlobalSearchEmptyState({ query }: GlobalSearchEmptyStateProps) {
  return (
    <div className="flex flex-col items-center gap-2 px-4 py-8 text-center">
      <SearchX size={24} className="text-text-muted" aria-hidden />
      <Text variant="body-md" color="muted">
        No results for &ldquo;{query}&rdquo;
      </Text>
      <Text variant="body-sm" color="subtle">
        Try a different name, identifier, or registration number.
      </Text>
    </div>
  );
}
